import React from 'react';
import {Button} from 'legacy_components/Button';
import {DuplicateTableRow} from 'legacy_components/DuplicateTableRow';
import {Modal} from 'legacy_components/Modal';
import styles from 'legacy_css_modules/DuplicateModal.module.css';

export const DuplicateSModal = ({duplicates, clickedClose, clickedOkAll, clickedOkNonduplicit,docs,ignoreAccYearWarning}) => {
    console.log(docs)
    console.log(ignoreAccYearWarning)
    const currentYear = new Date().getFullYear();
    if (ignoreAccYearWarning==="current"){
        docs = docs.filter(doc => doc.accounting_year === currentYear);
    }
    const count = duplicates.filter(duplicate => duplicate.duplicates.length > 0).length;

    const getCzechDocWord = (n) => {
        if (n === 1) return 'doklad';
        if (n >= 2 && n <= 4) return 'doklady';
        return 'dokladů';
    };

    return (
        <div className={styles.ontop}>
            <Modal name={`Duplicitní záznamy nalezeny pro ${count} ${getCzechDocWord(count)}`} close={clickedClose}>
                <main className={styles.body}>
                    {duplicates
                        .filter(duplicate => duplicate.duplicates.length > 0)
                        .map((duplicate, i) => (
                            <div className={styles.block} key={duplicate.document + "_" + i}>
                                <p>
                                   {`Doklad ${duplicate.document} je shodný s ${
                                    duplicate.duplicates.length > 1
                                        ? `${duplicate.duplicates.length} jinými doklady`
                                        : 'jiným dokladem'
                                    }:`}

                                </p>
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Popis dokladu</th>
                                            <th>Stav</th>
                                            <th>Vytvořil</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {duplicate.duplicates.map(d => (
                                            <DuplicateTableRow key={d.uuid} duplicate={d} />
                                        ))}
                                    </tbody>
                                </table>
                                
                            </div>
                        ))}
                </main>
                <footer
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'auto 1fr auto auto',
                        gap: '0.5rem',
                        alignItems: 'center',
                        margin: '1rem',
                    }}
                    >
                    <Button onClick={clickedClose} style={{ width: '100%' }}>
                        Zrušit
                    </Button>
                    <div /> 
                    {(duplicates.length !== 1 && docs.length-duplicates.filter(duplicate => duplicate.duplicates.length > 0).length!==0) ? (
                        <>
                        <Button onClick={clickedOkNonduplicit} style={{ width: '100%' }}>
                            Odeslat jen doklady bez duplicit ({docs.length-duplicates.filter(duplicate => duplicate.duplicates.length > 0).length})
                        </Button>
                         <Button primary onClick={clickedOkAll} style={{ width: '100%' }}>
                                {docs.length === 1 ? 'Odeslat' : `Odeslat vše (${docs.length})`}
                            </Button>
                        </>
                    ) : (
                        <>
                        <div />
                            <Button primary onClick={clickedOkAll} style={{ width: '100%' }}>
                                {docs.length === 1 ? 'Odeslat' : `Odeslat vše (${docs.length})`}
                            </Button>
                        </>
                    )}
                    </footer>

            </Modal>
        </div>
    );
};
